import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Box, CircularProgress } from "@material-ui/core";
import { LinkinBioImageList, LinkinBioHeader, SocialMediaIcons, CtaButtons, LinkinBioSkeleton, } from "./";
import { CDNContext } from "../../constants/cdnContext";
var Loader = function () { return (React.createElement(Box, { style: { display: "flex", justifyContent: "center", overflow: "hidden" } },
    React.createElement(CircularProgress, null))); };
var makeBanner = function (metaData, firstPost) {
    if (metaData.banner)
        return metaData.banner;
    var displaySettings = metaData.displaySettings || {};
    if (displaySettings.useLatestPostAsBanner && firstPost) {
        return {
            altText: firstPost.altText,
            link: firstPost.link,
            bannerUrl: firstPost.fullSizeImageUrl,
            serviceMessageId: firstPost.serviceMessageId,
        };
    }
    return;
};
export function LinkinBio(_a) {
    var _b;
    var metaData = _a.metaData, articles = _a.articles, fetchArticles = _a.fetchArticles, _c = _a.scrollableTarget, scrollableTarget = _c === void 0 ? undefined : _c, loading = _a.loading, imageWrapper = _a.imageWrapper, bannerWrapper = _a.bannerWrapper, _d = _a.disableCDN, disableCDN = _d === void 0 ? false : _d, _e = _a.cdnRoot, cdnRoot = _e === void 0 ? '/' : _e;
    var fetch = function () {
        if (!articles)
            return;
        fetchArticles(articles[articles.length - 1]);
    };
    if (loading)
        return React.createElement(LinkinBioSkeleton, null);
    var cdnValues = {
        rootUrl: cdnRoot,
        disableCDN: disableCDN,
    };
    var banner = makeBanner(metaData, articles[0]);
    var filteredArticles = articles;
    if (banner && metaData.displaySettings && metaData.displaySettings.hideBannerPostFromList) {
        filteredArticles = articles.filter(function (article) { return article.serviceMessageId !== banner.serviceMessageId; });
    }
    return (React.createElement("div", null,
        React.createElement(CDNContext.Provider, { value: cdnValues },
            React.createElement(LinkinBioHeader, { metaData: metaData }),
            metaData.socialMediaButtons && (React.createElement(SocialMediaIcons, { socialMediaButtons: metaData.socialMediaButtons })),
            ((_b = metaData.ctaButtons) === null || _b === void 0 ? void 0 : _b.length) ? (React.createElement(CtaButtons, { ctaButtons: metaData.ctaButtons })) : (React.createElement(React.Fragment, null)),
            React.createElement(InfiniteScroll, { dataLength: filteredArticles.length || 0, next: function () { return fetch(); }, loader: React.createElement(Loader, null), scrollableTarget: scrollableTarget, hasMore: metaData.hasMoreArticles || false },
                React.createElement(LinkinBioImageList, { banner: banner, articles: filteredArticles, bannerWrapper: bannerWrapper, imageWrapper: imageWrapper })))));
}
